/* eslint-disable */
export const maxLifetime = 24

export default [
[ 0, 1000 ],
[ 1, 620 ],
[ 2, 407 ],
[ 3, 279 ],
[ 4, 201 ],
[ 5, 134 ],
[ 6, 78 ],
[ 7, 54 ],
[ 8, 34 ],
[ 9, 27 ],
[ 10, 18 ],
[ 11, 0 ]
]
